import React from 'react';
import { useNavigate } from 'react-router-dom';

const RoomBookingRulesModal = ({ show, onClose }) => {
    const navigate = useNavigate();

    if (!show) return null;

    const handleProceed = () => {
        onClose();
        navigate('/bookingroom');
    };

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"> {/* Added modal-dialog-scrollable */}
                <div className="modal-content">
                    {/* Simplified Header just for the close button */}
                    <div className="modal-header border-0 pb-0 position-relative">
                        <button type="button" className="btn-close ms-auto" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body pt-0">
                        {/* Title moved inside body so it never gets cut off by strict header flex constraints */}
                        <h5 className="modal-title fw-bold text-center w-100 text-danger mb-3" style={{ fontSize: '1.25rem', textDecoration: 'underline' }}>
                            Kind attention to all devotees visiting Divyakshetra Hariharapura
                        </h5>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item border-0 py-1">1) Booking can be made for a Maximum of 3 days.</li>
                            <li className="list-group-item border-0 py-1">2) Post confirmation of booking, there will be no cancellation, no refund or change in date/time.</li>
                            <li className="list-group-item border-0 py-1">3) Each room can accommodate 2 adults and 2 Children. Another adult can be accommodated with an extra Bed ( Extra bed at additional cost)</li>
                            <li className="list-group-item border-0 py-1">4) Extra bed or bedding will be provided at additional cost.</li>
                            <li className="list-group-item border-0 py-1">5) You may book rooms up to 90 days in advance.</li>
                            <li className="list-group-item border-0 py-1">6) Divyakshetra Hariharapura reserves the right to cancel any booking at any time.</li>
                            <li className="list-group-item border-0 py-1">7) Advance booking of Rooms can be made only through this website</li>
                        </ul>
                        <div className="alert alert-warning mt-3 mb-0 text-center fw-bold text-dark border-danger">
                            For Phone booking or enquiry Please call +91 94818 30694.
                        </div>
                    </div>
                    <div className="modal-footer border-0 justify-content-center pt-0 pb-4">
                        <button
                            type="button"
                            className="btn btn-danger px-5"
                            onClick={handleProceed}
                            style={{ backgroundColor: '#a71919', borderColor: '#a71919' }}
                        >
                            PROCEED
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoomBookingRulesModal;
